module.exports = __webpack_public_path__ + "static/img/rank_61.a212667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_61.png
// module id = 6g4M
// module chunks = 1